"use client";

import { SessionProvider as NextAuthSessionProvider } from "next-auth/react";

/**
 * Configured SessionProvider that balances freshness with efficiency.
 *
 * - refetchOnWindowFocus: true (default) – ensures the session is fresh when
 *   a user returns to the tab. This is critical for enforcing deactivation:
 *   when an admin disables a user, the JWT callback checks isActive and
 *   forces sign-out on the next refetch. Without this, a returning user
 *   could wait up to 5 min before being logged out. The cost is one
 *   /api/auth/session call per tab-focus event, which is lightweight.
 *
 * - refetchInterval: 5 min – keeps the session fresh for background tabs
 *   that never lose/regain focus. Components can still call `update()` for
 *   an immediate refresh when they actually need one (e.g. impersonation).
 */
const SESSION_REFETCH_INTERVAL_SECONDS = 5 * 60; // 5 minutes

export default function SessionProvider({ children, ...props }) {
  return (
    <NextAuthSessionProvider
      {...props}
      refetchInterval={SESSION_REFETCH_INTERVAL_SECONDS}
    >
      {children}
    </NextAuthSessionProvider>
  );
}
